
import { Component, Vue } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import WithdrawDepositApi from "@/common/api/financeManage/withdrawDeposit";
import { excuteDownloadExport2Excel } from "@/common/xlsx";

import { getCommonList, shareConfirmOptions } from "@/common/config";

const defaultForm: any = {
 // searchKw: "", // 搜索用户昵称/用户ID/手机号
  shop_id: "", // 店铺ID
  name: "", // 店铺昵称

  time: [], // 时间选择
  is_corporation: 0,
  auditStatus: 1, // 审核状态
}

const defaultAllinpayForm: any = {
  channel: "",
};

// 通联支付渠道 1中间户  2子户
const allinpayChannel2Ch: string[] = ["", "中间户", "子户"];

// 提现类型 0全部 1否 2是
const withdrawCorporation2Ch: string[] = ['', '非法人', '法人']

// 状态 1待审核（审核中） 2审核通过、打款成功  3驳回、打款失败  4打款中  6提现异常   7失败处理中（失败处理中）8打款失败处理中（失败处理中）
const defaultAuditStatus2ch: any = {
  1: "审核中",
  2: "审核通过(打款成功)",
  3: "驳回(打款失败)",
  4: "打款中",
  5: "打款失败",
  6: "提现异常",
  7: "失败处理中",
  8: "打款失败处理中",
};

// 快钱 查询状态类型
// 提现状态  1交易成功  2交易失败 3交易处理中 4交易退票
const defaultWithdrawQueryStatus2ch: string[] = [
  "",
  "交易成功",
  "交易失败",
  "交易处理中",
  "交易退票",
];

// 通联 提现状态 1，提现中 2，交易成3，提现失败
const defaultWithdrawQueryAllinStatus2Ch: string[] = [
  "",
  "提现中",
  "提现成功",
  "提现失败",
];

// 预转账 0否  1是
const preTransferStatus2Ch: string[] = ["处理中", "处理成功"];

export const pageApiList = getPageAPIs(WithdrawDepositApi);

@Component({
  filters: {
    showWithdrawQueryStatus(status: number) {
      return defaultWithdrawQueryStatus2ch[status] || "";
    },
    showWithdrawQueryAllinStatus(status: number) {
      return defaultWithdrawQueryAllinStatus2Ch[status] || "";
    },
    showPreTransferStatusName(status: number) {
      return preTransferStatus2Ch[status];
    },

    showWithdrawCorporationName(is_corporation: number) {
      return withdrawCorporation2Ch[is_corporation] || ''
    }
  },
})
export default class WithdrawDeposit extends Vue {
  private utilInstance: any;
  private withdrawDepositApi: any;

  private commonApi: any;

  private deepLoopUtil: any;

  // 自动审核 开关  状态 1开启  2未开启  开启后 每天凌晨1：00自动审核
  private isAutoAduit: number = 2;

  private chooseAllinpayChannel: any[] = [
    ...getCommonList(allinpayChannel2Ch, 1),
  ];

  private chooseWithdrawCorporationList: any[] = [
    ...getCommonList(withdrawCorporation2Ch, 1)
  ]

  private allinpayForm: any;

  constructor() {
    super();
    this.withdrawDepositApi = new WithdrawDepositApi();

    // this.commonApi = new CommonApi();

    this.deepLoopUtil = new DeepLoop();

    this.utilInstance = new Util();

    
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };

    this.allinpayForm = {
      ...this.deepLoopUtil.deepCopy(defaultAllinpayForm, false),
    };

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  private withdrawTip: string = `注：提现需在每日上午10:30分前全部进行 付款申请，付款渠道选择，否则将无法提现。
11:00分系统将会进行从平台账号转账到商户账号中，下午14:00分系统会自动为商户发起提现，将金额打入商户银行账号中。`;

  private form: any = {
   
  };

  // private show: boolean = false;

  // 状态  0全部  1待审核 2打款成功 3打款失败 4打款中   5提现异常 6失败处理中
  private auditStatusList: any[] = [
    {
      value: 0,
      label: "全部",
    },
    {
      value: 1,
      label: "审核中",
    },
    {
      value: 2,
      label: "审核通过",
    },
    {
      value: 3,
      label: "驳回(打款失败)",
    },
    {
      value: 4,
      label: "打款中",
    },
    {
      value: 5,
      label: "提现异常",
    },
    {
      value: 6,
      label: "失败处理中",
    },
  ];

  private checkboxConfig: any = {
    checkMethod: ({ row }: any) => {
      // 是否设置通联支付账户  0否 1是    // 只有审核中的 才能选中
      return row.is_allinpay_account === 0 && row.is_status == 1;
    },
  };

  private curChooseRows: any[] = [];

  private onSelectAllCheckBox({ selection }: any) {
    console.log(selection, "selection");

    if (Array.isArray(selection) && selection.length) {
      this.curChooseRows = selection;
    } else {
      this.curChooseRows = [];
    }
  }

  private onSelectCheckBox({ selection }: any) {
    console.log(selection, "selection");
    if (Array.isArray(selection) && selection.length) {
      this.curChooseRows = selection;
    } else {
      this.curChooseRows = [];
    }
  }

  private allinpayMode: string = ""; // single  mutiple

  private curAllinpayItem: any;

  private onWakeAllinpay(mode: string, row: any = null) {
    this.allinpayMode = mode;
    this.curAllinpayItem = row;

    this.allinpayForm = {
      ...this.deepLoopUtil.deepCopy(defaultAllinpayForm, false),
    };

    this.dialogAllinpayFormVisible = true;
  }

  private dialogAllinpayFormVisible: boolean = false;

  private submitAllinpayLoading: boolean = false;

  private onSumbitAllinpayChannel() {
    const params = this.getAllinpayChannelParams()


    if (typeof params !== 'object') return 


    console.log(params, 'params')
    // return 

    this.submitAllinpayLoading = true

    this.withdrawDepositApi.sendAllinpayChannel(params, (res: any) => {
      const {
        total = 0
      } = res.data || {} 

      this.$message.success(`已成功执行${total}条`)

      this.submitAllinpayLoading = false
      this.dialogAllinpayFormVisible = false

      this.getTable()
    }, (err: any) => {
      this.submitAllinpayLoading = false
    })
    
  }

  private getAllinpayChannelParams() {
    const allinpayForm = this.allinpayForm;
    const mode = this.allinpayMode

    const { channel } = allinpayForm;

    const singleAllinpayItem = this.curAllinpayItem
    const mutilpleAllinpayItems = this.curChooseRows

    console.log(singleAllinpayItem, 'singleAllinpayItem')
    console.log(mutilpleAllinpayItems, 'mutilpleAllinpayItems')

    if (!channel) {
      this.$message.error('请选择付款账户')
      return false
    }

    const params: any = {
      channel
    }

    switch(mode) {
      case 'single':
        Object.assign(params, {
          withdraw_id: singleAllinpayItem.id
        })

        break;
      case 'mutiple':
        if (Array.isArray(mutilpleAllinpayItems) && mutilpleAllinpayItems.length > 0) {
          Object.assign(params, {
            withdraw_ids: mutilpleAllinpayItems.map((item: any) => item.id)
          })
        } else {
          this.$message.error('请至少选择一个店铺')
          return false
        }
        break;
    }

    return params
  }

  private onCancelAllinpayChannel(allinpayItem: any) {
    this.$confirm(`确定是否取消该店铺付款？`, "取消付款", {
      ...shareConfirmOptions,
      // type: "warning",
    }).then(() => {
      this.withdrawDepositApi.cancelAllinpayChannel({
        id: allinpayItem.id
      }, (res: any) => {
        this.$message.success('已取消店铺付款')

        this.getTable()
      }, (err: any) => {})
    })
  }

  // private showtimecard: boolean = false;
  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.withdrawDepositApi.getAutoAuditSetting(
      {},
      (res: any) => {
        const { is_state } = res.data || {};

        this.isAutoAduit = is_state;
      },
      () => {}
    );

    this.withdrawDepositApi.getWithdrawTableList(
      this.getUserTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        // totalCount: 0,
        // pageNo: 1,
        // pageSize: 10,
        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getUserTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      shop_id, // 店铺ID
      name: shop_name, // 店铺昵称

      time, // 时间选择
      auditStatus, // 审核状态
    } = form || {};

    // console.log(technicianItem, "technicianItem");

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    if (shop_id) {
      outerParams.shop_id = shop_id;
    }

    if (shop_name) {
      outerParams.name = shop_name;
    }

    if (auditStatus) {
      outerParams.is_status = auditStatus;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.start_date = startTime;

      outerParams.end_date = endTime;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择时段导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {
      // userId,
      // gender,
      identity,
      money,
      actual_money: actualMoney,
      surplus_money: surplusMoney,
      withdrawal_account: withdrawalAccount,
      realname,
      created_at: ctime,
      examine_time: examineTime,
      examine_user: examineUser,
      is_status: isStatus,
      // activeTime,
      // nickname,
      // avatarUrl,
      // mobile,
      // forbidTime,
    } = data;
    const auditStatus = defaultAuditStatus2ch[isStatus] || "未知审核状态";
    const newData = {
      ...data,
      identify: identity,
      withdrawMoney: money,
      actualMoney,
      restWithdrawMoney: surplusMoney,
      withDrawAccount: withdrawalAccount,
      alipayActualName: realname,
      withdrawTime: ctime,
      auditTime: examineTime,
      auditOpUser: examineUser,
      auditStatus,
    };

    return newData;
  }

  private isShowAgreeBtn(row: any) {
    const { is_status: isStatus, is_pre_transfer } = row || {};

    // 是否预转账 0否  1是
    return is_pre_transfer == 1 && isStatus == 1;
  }

  private isShowDisagreeBtn(row: any) {
    const { is_status: isStatus, is_pre_transfer } = row || {};

    return is_pre_transfer == 1 && isStatus == 1;
  }

  private handleRefreshAuditSetting(val: number) {
    console.log(val, "val");

    this.withdrawDepositApi.updateAutoAuditSetting(
      {
        is_state: val,
      },
      () => {
        this.$message.success("自动审核开关更改成功");
      }
    );
  }

  // 修改审核状态
  private handleChangeAuditStatus(withdrawItem: any, mode: string) {
    const mode2MessageTip: any = {
      agree: "通过",
      disagree: "驳回",
    };
    this.$confirm(`是否确定${mode2MessageTip[mode]}?`, "提示", {
      ...shareConfirmOptions,
      // type: "warning",
    }).then(() => {
      switch (mode) {
        case "agree":
          set(
            this,
            this.tableData,
            withdrawItem,
            "__changeAuditStatusAgreeLoading",
            true
          );

          this.withdrawDepositApi.getAuditAgree(
            {
              id: withdrawItem.id,
            },
            () => {
              set(
                this,
                this.tableData,
                withdrawItem,
                "__changeAuditStatusAgreeLoading",
                false
              );
              this.getTable();
            },
            () => {
              set(
                this,
                this.tableData,
                withdrawItem,
                "__changeAuditStatusAgreeLoading",
                false
              );
            }
          );
          break;
        case "disagree":
          set(
            this,
            this.tableData,
            withdrawItem,
            "__changeAuditStatusDisagreeLoading",
            true
          );

          this.withdrawDepositApi.getAuditDisagree(
            {
              id: withdrawItem.id,
            },
            () => {
              set(
                this,
                this.tableData,
                withdrawItem,
                "__changeAuditStatusDisagreeLoading",
                false
              );
              this.getTable();
            },
            () => {
              set(
                this,
                this.tableData,
                withdrawItem,
                "__changeAuditStatusDisagreeLoading",
                false
              );
            }
          );
          break;
      }
    });

    function set<T>(vm: any, list: T[], item: T, key: string, val: any) {
      const existIndex = list.findIndex((eachItem) => eachItem == item);

      if (existIndex > -1) {
        if (item && typeof item == "object" && !Array.isArray(item))
          vm.$set(list[existIndex], key, val);
      }
    }
  }

  private dialogFormVisible: boolean = false;

  private withdrawQueryInfo: any = {};

  private withdrawManualSetLoading: boolean = false;

  private withdrawManualState: number = 0;

  // 提现状态查询
  private handleWakeQueryMoneyFlow(withdrawItem: any) {
    console.log(withdrawItem, "withdrawItem");
    set(
      this,
      this.tableData,
      withdrawItem,
      "__moneyTransferQueryLoading",
      true
    );

    this.withdrawDepositApi.getWithdrawQueryInfo(
      {
        id: withdrawItem.id,
      },
      (res: any) => {
        set(
          this,
          this.tableData,
          withdrawItem,
          "__moneyTransferQueryLoading",
          false
        );

        const { data: withdrawQueryInfo } = res || {};

        const { kuaiqian, resp_type, allinpay } = withdrawQueryInfo;

        this.withdrawQueryInfo = {
          _resp_type: resp_type,
          ...(withdrawQueryInfo[resp_type] || {}),
        };

        this.dialogFormVisible = true;
      },
      () => {
        set(
          this,
          this.tableData,
          withdrawItem,
          "__moneyTransferQueryLoading",
          false
        );
      }
    );

    function set<T>(vm: any, list: T[], item: T, key: string, val: any) {
      const existIndex = list.findIndex((eachItem) => eachItem == item);

      if (existIndex > -1) {
        if (item && typeof item == "object" && !Array.isArray(item))
          vm.$set(list[existIndex], key, val);
      }
    }
  }

  private handleWithdrawSetSuccess(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      state,
    };

    this.withdrawManualSet(params);
  }

  private handleWithdrawSetFail(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      state,
    };

    this.withdrawManualSet(params);
  }

  private withdrawManualSet(params: any) {
    this.withdrawManualSetLoading = true;
    this.withdrawDepositApi.withdrawManualSetStatus(
      params,
      () => {
        this.$message.success("标记状态完成");

        this.withdrawManualSetLoading = false;

        this.dialogFormVisible = false;

        this.getTable();
      },
      () => {
        this.withdrawManualSetLoading = false;
      }
    );
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 用户字段名 文案对应关系
  private userExcelList2ch: any = {
    shop_id: "店铺ID",
    name: "店铺昵称",
    mobile: "手机号码",
    money: "提现金额（元）",
    fee_money: "手续费",
    actual_money: "实际到账金额",
    // realname: "用户名",
    // bank_name: "银行",
    // province_city: "省市",
    // branch_name: "支行",
    // bank_card: "银行卡号",
    _withdrawCorportationName: "提现类型",
    created_at: "提现时间",
    examine_time: "审核时间",
    examine_user: "审核人",
    auditStatus: "打款状态",
    _preTransferStatusName: "预转账状态",
  };
  // 用户Excel 表头的先后顺序
  private userExcelSortList: string[] = [
    "shop_id",
    "name",
    "mobile",
    "money",
    "fee_money",
    "actual_money",
    // "realname",
    // "bank_name",
    // "province_city",
    // "branch_name",
    // "bank_card",
    "_withdrawCorportationName",
    "created_at",
    "examine_time",
    "examine_user",
    "auditStatus",
    "_preTransferStatusName",
  ];

  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getUserTableListParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.withdrawDepositApi.exportExcelWithdrawList(
      params,
      (res: any) => {
        const { start_date, end_date } = params || {};

        const filename = `提现列表 ${start_date}到${end_date}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { is_status: isStatus, is_corporation, mobile, is_pre_transfer } = item;
              const newItem = {
                ...(item || {}),
                _withdrawCorportationName: withdrawCorporation2Ch[is_corporation] || '',
                _preTransferStatusName: preTransferStatus2Ch[is_pre_transfer],
              };

              if (isStatus) {
                newItem.auditStatus =
                  defaultAuditStatus2ch[isStatus] || "未知审核状态";
              }

              if (typeof mobile == "number") {
                newItem.mobile = mobile.toString();
              }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const userExcelSortList = this.userExcelSortList;

          const userExcelList2ch = this.userExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            userExcelSortList,
            userExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };


    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }
}
